<div class="sabis-loader">
  <div class="sabis-loader__viewport" *ngIf="!internal">
    <img src="assets/loading/double-ring.svg" alt="Please wait..." />
    {{ text }}
  </div>
  <div class="sabis-loader__inner-page" *ngIf="internal">
    <img src="assets/loading/Pulse-1s-200px.svg" alt="Please wait..." />
    {{ text }}
  </div>
</div>
